import { Component, Input, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { TooltipDirective } from '@shared/directives/tooltip.directive';
import {
  listDriverCustomGroupsQuery,
  listDriverCustomGroupsWithDataQuery,
} from '@shared/services/gql.service';

import { ForecastTableGridMethodChange } from '../../models/forecast-table-grid.model';

@Component({
  imports: [NgSelectModule, FormsModule, TooltipDirective],
  selector: 'aux-forecast-table-grid-method-custom-curve',
  styleUrl: './forecast-table-grid-method-custom-curve.component.scss',
  templateUrl: './forecast-table-grid-method-custom-curve.component.html',
})
export class ForecastTableGridMethodCustomCurveComponent {
  categoryId = input.required<string>();
  customCurves = input.required<listDriverCustomGroupsWithDataQuery[]>();
  disabled = input(false);
  isChild = input(false);
  onMethodChange = input.required<ForecastTableGridMethodChange>();
  primarySettingsId = input.required<string>();
  tooltip = input('');

  @Input() isInvalid = false;
  @Input() selectedCurve?: string = undefined;

  modelChange(event?: listDriverCustomGroupsQuery): void {
    const driver_setting_id = event?.driver_setting_id || null;

    const change = this.onMethodChange();

    change(driver_setting_id, this.primarySettingsId(), {
      id: this.categoryId(),
      name: !this.isChild() ? 'category' : 'activity',
      prop: 'driver_setting',
    });
  }
}
